import { render, staticRenderFns } from "./PrimeroCaseStudy.vue?vue&type=template&id=e4dac5c2&scoped=true"
import script from "./PrimeroCaseStudy.vue?vue&type=script&lang=js"
export * from "./PrimeroCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./PrimeroCaseStudy.vue?vue&type=style&index=0&id=e4dac5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dac5c2",
  null
  
)

export default component.exports